import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Communication } from '../../../../graphql/comms.datatypes';
import { updateCacheByType } from '../../../../graphql/GraphQlProvider';
import { gqlCommunication } from '../getCommunication.api';

interface CreateCommunicationInput {
  data: {
    ident?: string
    title?: string
    body?: string
    active?: boolean
    communication_type?: number
    receiver?: number
    log_code?: string
    mandatory?: boolean
  }
}

interface CreateCommunicationData {
  createCommunication: Communication
}

export const CREATE_ROLE_MUTATION = gql`
    mutation createCommunication($data: CreateCommunicationInput!) {
        createCommunication(data: $data) {
            ${gqlCommunication}
        }
    }
`;

export const createCommunication = () => useMutation<CreateCommunicationData, CreateCommunicationInput>(
  CREATE_ROLE_MUTATION,
  {
    update: updateCacheByType('Communication'),
  }
);

export default createCommunication;